module.exports = __webpack_public_path__ + "img/sign_up_success.565d1bd6.png";